<div
	(click)="markAsRead(notification)"
	class="p-[12px] mb-[12px] {{
		notification?.isReaded?.toString() != 'false'
			? 'bg-off-white border-b-2'
			: 'bg-[#EFF0F6]'
	}} flex rounded-[6px] relative cursor-pointer"
>
	<div
		class="{{
			!isDropDown
				? ' rounded-full flex justify-center  w-[40px] h-[40px]'
				: ' rounded-full flex justify-center   w-[70px] h-[70px]'
		}} ltr:mr-2 rtl:ml-2 p-2"
		[ngClass]="
			notification?.isReaded?.toString() != 'false'
				? 'bg-transparent border-2 '
				: 'bg-[#FCFCFC] not-shadow '
		"
	>
		<img
			class="{{
				isDropDown ? 'cursor-pointer  w-[50px]' : 'h-[24px] w-[24px]'
			}}"
			[src]="imgPath + '/' + notification?.imageUrl"
			alt=""
		/>
	</div>
	<div
		class="{{
			isDropDown
				? 'max-w-[60%] ltr:mr-[25px] rtl:ml-[25px]'
				: '[16px] mx-3 max-w-[80%]'
		}}"
	>
		<p
			class="font-poppins font-normal text-[14px] text-dark-grey leading-[22px] mb-0 pb-0"
		>
			{{
				translate.currentLang == 'ar'
					? notification?.title?.ar || notification?.titleAr
					: notification?.title?.en || notification?.titleEn
			}}
		</p>
		<p
			class="font-poppins-normal text-[14px] text-[#6E7191] leading-[22px] mb-0 pb-0"
		>
			{{
				translate.currentLang == 'ar'
					? notification?.body?.ar || notification?.bodyAr
					: notification?.body?.en || notification?.bodyEn
			}}
		</p>
	</div>
	<div class="m-auto mx-4 pt-3">
		<p
			class=" {{
				notification?.isReaded?.toString() != 'false'
					? 'text-[#6E7191]'
					: 'text-gradient'
			}}  absolute ltr:right-5 rtl:left-5 top-8 {{
				isDropDown ? 'max-w-[60px]' : 'whitespace-nowrap'
			}}"
		>
			<span *ngIf="checkIfToday(notification?.creationTime)"
				>{{ 'GENERAL.TODAY' | translate }} ,
			</span>
			{{
				notification?.creationTime
					| date
						: (checkIfToday(notification?.creationTime) ? 'shortTime' : 'short')
			}}
		</p>
	</div>
</div>
